<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-descending-sorting`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.558 42.553a1 1 0 00.442-.83V6a1 1 0 00-1-1H9a1 1 0 00-1 1v25H3.17a.6.6 0 00-.487.95l7.326 10.176a.999.999 0 00.193.201l.038.048a1 1 0 001.317.178zM17 13h26a1 1 0 00.993-.883L44 12v-2a1 1 0 00-.883-.993L43 9H17a1 1 0 00-.993.883L16 10v2a1 1 0 00.883.993L17 13h26-26zm0 13h20a1 1 0 00.993-.883L38 25v-2a1 1 0 00-.883-.993L37 22H17a1 1 0 00-.993.883L16 23v2a1 1 0 00.883.993L17 26zm14 13a1 1 0 00.993-.883L32 38v-2a1 1 0 00-.883-.993L31 35H17a1 1 0 00-.993.883L16 36v2a1 1 0 00.883.993L17 39h14z"/></svg>
</template>
<script>

export default {
  name: 'IconDescendingSorting',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
